<template>
  <el-form-item prop="variableArr" ref="formItem" verify :rules="variableArrRules" class="sky-server-config">
    <div
      :class="['sky-server-config__item', 'sk-font--B', isFill(item) && 'active']"
      v-for="(item, index) in variableArr"
      :key="index"
    >
      <i class="el-icon-arrow-right" />
      <el-select
        v-model="item.sceneId"
        popper-class="sky-server-config__autocomplete"
        class="sky-server-config__select"
        placeholder="请选择用户场景"
        filterable
        style="width: 380px!important"
        @change="sceneChange(item)"
        @visible-change="filterScene()"
      >
        <el-option
          v-for="(obj, index) in sceneList"
          :key="index"
          :label="$t(obj.label)"
          :value="obj.id"
          :disabled="obj.noSelect"
        >
        </el-option>
      </el-select>
      <i class="el-icon-arrow-right" />
      <el-select
        v-model="item.segmentSceneId"
        popper-class="sky-server-config__autocomplete"
        class="sky-server-config__select"
        placeholder="请选择细分场景"
        filterable
        style="width: 380px!important"
        @change="sendDataBack"
      >
        <el-option
          v-for="(entity, index) in segmentSceneMap[item.sceneId]"
          :key="index"
          :label="$t(entity.segmentName)"
          :value="entity.id"
        >
        </el-option>
      </el-select>
      <i class="sk-icon-remove sk-font--B" v-if="index !== 0" @click="handleDelete(index)"></i>
    </div>

    <el-button type="primary" class="sky-branch-pattern__add" style="margin-top:5px;display: none;" @click="handleAdd">
      添加场景
    </el-button>
  </el-form-item>
</template>
<script type="text/babel">
import { Select, Option, Input, Button } from 'element-ui'
import { action } from 'sky-engine/api'

import { SCENE_MNG } from '@/api/apiModules'

export default {
  name: 'SkyCalSceneSegmentSceneRela',
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [Input.name]: Input,
    [Button.name]: Button
  },
  props: {
    industryId: {
      type: String
    },
    value: {
      type: [String, Array],
      default: ''
    }
  },
  data() {
    return {
      sceneList: [],
      segmentSceneMap: {},
      variableArr: [{ sceneId: null, segmentSceneId: null }]
    }
  },
  mounted() {
    this.variableArr = this.value
    if (this.industryId) {
      action(SCENE_MNG, '/industry/sceneList', { id: this.industryId }).then(response => {
        this.sceneList = response.data.content.map(item => {
          this.segmentSceneMap[item.id] = item.specCalSegmentSceneList
          return {
            id: item.id,
            label: item.sceneName,
            noSelect: false,
            specCalSegmentSceneList: item.specCalSegmentSceneList
          }
        })
      })
    }
  },
  computed: {
    variableArrRules() {
      const validatorBranch = (rule, value, callback) => {
        let hasError = false
        if (this.variableArr.length) {
          for (const data of this.variableArr) {
            if (!this.isFill(data)) {
              hasError = true
              callback(new Error(this.$t('一级或细分场景不能为空')))
              break
            }
          }
        }
        if (this.isDuplicate()) {
          hasError = true
          callback(new Error(this.$t('一级场景不能重复')))
        }
        if (!hasError) {
          callback()
        }
      }
      return [[{ validator: validatorBranch, trigger: ['blur', 'change'] }]]
    }
  },
  watch: {
    value(value) {
      if (this.value.length) {
        this.handleFill(value)
      }
    },
    variableArr: {
      handler: function(value) {
        this.$emit('input', value)
      },
      deep: true
    }
  },
  methods: {
    filterScene() {
      // 提取 variableArr 中的 sceneId
      const excludedIds = this.variableArr.map(item => item.sceneId)
      // 过滤 sceneList，排除掉 excludedIds 中的元素
      this.sceneList.forEach(scene => {
        if (excludedIds.includes(scene.id)) {
          scene.noSelect = true
        } else {
          scene.noSelect = false
        }
      })
    },
    sceneChange(item) {
      if (this.segmentSceneMap[item.sceneId].length === 1) {
        item.segmentSceneId = this.segmentSceneMap[item.sceneId][0].id
      } else {
        item.segmentSceneId = null
      }
    },
    sendDataBack() {
      this.variableArr.forEach(item => {
        this.sceneList.forEach(obj => {
          if (obj.id === item.sceneId) {
            obj.specCalSegmentSceneList.forEach(entity => {
              if (entity.id === item.segmentSceneId) {
                item.sceneName = obj.label
              }
            })
          }
        })
      })
      this.$emit('childSceneSegmentSceneRela', this.variableArr)
    },
    isFill(item) {
      return item.sceneId && item.segmentSceneId
    },
    isDuplicate() {
      if (this.variableArr.length) {
        const set = new Set()
        return this.variableArr.some(obj => {
          const combination = obj['sceneId']
          if (set.has(combination)) {
            return true
          } else {
            set.add(combination)
          }
        })
      }
    },
    handleAdd() {
      if (this.variableArr.length === this.sceneList.length) {
        this.$store.dispatch('OpenNotification', { message: '用户场景已满，无法继续添加', type: 'error' })
        return
      }
      this.variableArr.push({
        sceneId: null,
        segmentSceneId: null
      })
    },
    handleFill(value) {
      this.variableArr = value
    },
    handleDelete(index) {
      this.variableArr.splice(index, 1)
    }
  }
}
</script>
<style lang="scss">
@import '~sky-engine/assets/styles/common/var.scss';
@import '~sky-engine/assets/styles/mixin/mixin.scss';

@include b(version-variable) {
  @include e(more-btn) {
    & .el-button {
      background-color: $--fill-base !important;
      color: $--color-primary !important;
      border: 0 !important;
      line-height: $--font-line-height-base - 0.2em;
      &:hover {
        color: $--color-primary-5 !important;
      }
    }
  }
}
@include b(server-config) {
  margin-bottom: 0px !important;
  @include e(autocomplete) {
    width: auto !important;
    min-width: 180px;
  }
  @include e(select) {
    width: 180px !important;
  }
  @include e(mutiple-select) {
    width: 300px !important;
  }
  @include e(item) {
    line-height: 30px;
    word-break: break-all;
    width: 1400px !important;
    color: $--disabled-color-base;
    &.active {
      color: $--color-primary;
    }
  }
  & i {
    margin-right: 5px;
  }
  & .el-input__inner {
    border-top: 0;
    border-left: 0;
    border-right: 0;
    padding: 0;
  }
  & .el-form-item__error {
    width: 500px !important;
  }
}
</style>
